"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var Routes_1 = require("../../constants/Routes");
var currencySlice_1 = require("../../features/currencies/currencySlice");
var languageSlice_1 = require("../../features/languages/languageSlice");
var useActionForbidden_1 = require("../../hooks/useActionForbidden");
var userSlice_1 = require("../../features/user/userSlice");
var registerSlice_1 = require("../../features/register/registerSlice");
var TopHeader_1 = __importDefault(require("./TopHeader"));
var BottomHeader_1 = __importDefault(require("./BottomHeader"));
var SubHeader_1 = __importDefault(require("./SubHeader"));
var NewHomeHeader_1 = __importDefault(require("./NewHomeHeader"));
var localization_1 = require("../../helpers/localization");
var useDeviceResize_1 = require("../../hooks/useDeviceResize");
var postSlice_1 = require("../../features/post/postSlice");
var globalSlice_1 = require("../../features/global/globalSlice");
var useSelectSearchPageAddress_1 = require("../../hooks/useSelectSearchPageAddress");
var useLocationPathName_1 = require("../../hooks/useLocationPathName");
var Localization_1 = require("../../constants/Localization");
var searchParamsSlice_1 = require("../../features/searchParams/searchParamsSlice");
var classnames_1 = __importDefault(require("classnames"));
var AppHeader = react_1.default.memo(function (_a) {
    var ToggleMobileMenu = _a.ToggleMobileMenu;
    var location = react_router_dom_1.useLocation();
    var dispatch = react_redux_1.useDispatch();
    var mobileResize = useDeviceResize_1.useDeviceResize(useDeviceResize_1.MediaQueries.mobile);
    var address = useSelectSearchPageAddress_1.useSelectSearchPageAddress(location);
    var locationPathName = useLocationPathName_1.useLocationPathName(location);
    var deal = react_1.useMemo(function () { return Localization_1.PagePrefix[locationPathName]; }, [locationPathName]);
    var seoCleanLocationSubDirectoryPrefix = react_redux_1.useSelector(searchParamsSlice_1.useSelectSeoCleanLocationSubDirectoryPrefix);
    var currentLanguage = react_redux_1.useSelector(languageSlice_1.selectCurrentLanguage);
    var languageList = react_redux_1.useSelector(languageSlice_1.selectLanguages);
    var currencyList = react_redux_1.useSelector(currencySlice_1.selectCurrencies);
    var currentCurrency = react_redux_1.useSelector(currencySlice_1.selectCurrentCurrency);
    var user = react_redux_1.useSelector(userSlice_1.useSelectUser);
    var isResetPassword = react_redux_1.useSelector(registerSlice_1.selectIsResetPassword);
    var postData = react_redux_1.useSelector(postSlice_1.selectSinglePost);
    var isOpenPostPreview = react_redux_1.useSelector(globalSlice_1.useSelectIsOpenPostPreview);
    var _b = react_1.useState(false), open = _b[0], setOpen = _b[1];
    var _c = react_1.useState(true), isScrollTop = _c[0], setIsScrollTop = _c[1];
    // Old home page had a transparent header over its picture; that page is
    // replaced by NewHome, which uses the regular white header.
    // const [isHomePage, setIsHomePage] = useState<boolean>(false);
    var _d = react_1.useState(false), isAnnouncementPage = _d[0], setIsAnnouncementPage = _d[1];
    // "/", "/ru", "/ru/", "/en" ... (the home page) get the header from the new
    // mockup: the language prefix and the trailing slash are cut off first.
    var isNewHomePage = (location.pathname
        .replace(/^\/(ru|hy|en)(?=\/|$)/, '')
        .replace(/\/$/, '') || '/') === Routes_1.Routes.Home.path;
    react_1.useEffect(function () {
        // setIsHomePage(location.pathname === Routes.Home.path);
        setIsAnnouncementPage(location.pathname.split('/')[1] === Routes_1.Routes.Announcement.name);
    }, [location]);
    react_1.useEffect(function () {
        isResetPassword && openAccountList();
    }, [isResetPassword]);
    var handleScroll = function () { return setIsScrollTop(!window.scrollY); };
    react_1.useEffect(function () {
        window.addEventListener('scroll', handleScroll, { passive: true });
        return function () { return window.removeEventListener('scroll', handleScroll); };
    }, []);
    var isStickyHeader = react_1.useMemo(function () {
        return !isScrollTop || isAnnouncementPage;
    }, [isScrollTop, isAnnouncementPage]);
    var conditionalOpenAccountList = useActionForbidden_1.useActionForbidden(function () {
        setOpen(!open);
    });
    var openAccountList = function () {
        conditionalOpenAccountList();
    };
    var languageChangeHandler = function (language) {
        if (!seoCleanLocationSubDirectoryPrefix) {
            isOpenPostPreview && mobileResize
                ? localization_1.handleChangeSPVLanguage(language, postData.id, postData.slug)
                : localization_1.handleChangeLocalization(language);
        }
        else {
            localization_1.handleChangeSEOCleanURLLocalization(seoCleanLocationSubDirectoryPrefix, currentLanguage, language, deal, locationPathName, address);
        }
    };
    var currencyChangeHandler = function (value) {
        dispatch(currencySlice_1.setCurrency(value));
    };
    return (react_1.default.createElement("div", { className: classnames_1.default('app-header', "lang-" + currentLanguage, isStickyHeader ? 'sticky_header' : 'default_header') },
        react_1.default.createElement(TopHeader_1.default, { currencyList: currencyList, currentCurrency: currentCurrency, currentLanguage: currentLanguage, languageList: languageList, isAnnouncementPage: isAnnouncementPage, languageChangeHandler: languageChangeHandler, currencyChangeHandler: currencyChangeHandler, hidePostButton: isNewHomePage }),
        isNewHomePage && (react_1.default.createElement(NewHomeHeader_1.default, { user: user, open: open, currentLanguage: currentLanguage, openMobileMenu: ToggleMobileMenu, openAccountList: openAccountList, onDismiss: function () { return setOpen(false); } })),
        !isNewHomePage && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(BottomHeader_1.default, { user: user, open: open, isAnnouncementPage: isAnnouncementPage, openMobileMenu: ToggleMobileMenu, openAccountList: openAccountList, currentLanguage: currentLanguage, onDismiss: function () { return setOpen(false); } }),
            react_1.default.createElement(SubHeader_1.default, { isAnnouncementPage: isAnnouncementPage })))));
});
exports.default = AppHeader;
